import Hero from "./Components/Hero";
import Footer from "../about/Components/Footer";
import Speakers from "./Components/Speakers";

// to fix: set hero as fixed
// change the arrow to &rarr;
// wrap header and footer in pink bg
// make nav sticky

function Schedule() {
  return (
    <>
      <Hero></Hero>
      <Speakers />
      {/* <Soon /> */}
      <Footer></Footer>
    </>
  );
}

export default Schedule;
